import React from "react";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";

const FeatureDescription = () => {
  const { t } = useTranslation("features");

  return (
    <div className="relative mx-auto mt-32 w-1/2 text-center font-title text-xl font-semibold lg:text-5xl">
      {t`description`}
      <div className="absolute top-0 left-0 -translate-x-full -translate-y-1/2">
        <Image src="/features/star.svg" alt="Star Icon" width={29} height={29} />
      </div>
      <div className="absolute bottom-0 right-0 translate-x-full translate-y-1/2">
        <Image src="/features/star.svg" alt="Star Icon" width={29} height={29} />
      </div>
    </div>
  );
};

export default FeatureDescription;
